import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface PageSectionProps {
  children: React.ReactNode;
  title?: string;
  icon?: string;
  className?: string;
}

const PageSection: React.FC<PageSectionProps> = ({
  children,
  title,
  icon,
  className = ''
}) => {
  const { getThemeStyles } = useTheme();
  const themeStyles = getThemeStyles();

  return (
    <div style={{
      backgroundColor: themeStyles.cardBackground,
      padding: '20px',
      borderRadius: '8px',
      marginBottom: '30px'
    }} className={className}>
      {title && (
        <h3 style={{
          color: themeStyles.primary,
          marginBottom: '20px',
          fontSize: '1.2rem',
          fontWeight: '600',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem'
        }}>
          {icon && <span>{icon}</span>}
          {title}
        </h3>
      )}
      {children}
    </div>
  );
};

export default PageSection;